import { A11yModule } from '@angular/cdk/a11y';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { MatSortModule } from '@angular/material/sort';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ReactiveTypedFormsModule } from '@rxweb/reactive-form-validators';
import { ChartsModule, ThemeService } from 'ng2-charts';
import { ToastrModule } from 'ngx-toastr';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ContactUsComponent } from './application/contact-us/contact-us.component';
import { CampaignAddChargesModalComponent } from './application/dashboard/campaign-add-charges-modal/campaign-add-charges-modal.component';
import { CampaignCancelModalComponent } from './application/dashboard/campaign-cancel-modal/campaign-cancel-modal.component';
import { CampaignDeleteModalComponent } from './application/dashboard/campaign-delete-modal/campaign-delete-modal.component';
import { CampaignEditUserModalComponent } from './application/dashboard/campaign-edit-user-modal/campaign-edit-user-modal.component';
import { CampaignPauseEditVisualsModalComponent } from './application/dashboard/campaign-pause-edit-visuals-modal/campaign-pause-edit-visuals-modal.component';
import { CampaignPauseModalComponent } from './application/dashboard/campaign-pause-modal/campaign-pause-modal.component';
import { CampaignRejectModalComponent } from './application/dashboard/campaign-reject-modal/campaign-reject-modal.component';
import { CampaignRelaunchModalComponent } from './application/dashboard/campaign-relaunch-modal/campaign-relaunch-modal.component';
import { CampaignStopModalComponent } from './application/dashboard/campaign-stop-modal/campaign-stop-modal.component';
import { CampaignsOverviewComponent } from './application/dashboard/campaigns-overview/campaigns-overview.component';
import { CampaignsPerformanceComponent } from './application/dashboard/campaigns-performance/campaigns-performance.component';
import { DashboardComponent } from './application/dashboard/dashboard.component';
import { LiveCampaignsComponent } from './application/dashboard/live-campaigns/live-campaigns.component';
import { MyAccountModule } from './application/my-account/my-account.module';
import { NewCampaignModule } from './application/new-campaign/new-campaign.module';
import { ScratchPadComponent } from './application/scratchpad/scratchpad.component';
import { PrivacyPolicyComponent } from './application/privacy-policy/privacy-policy.component';
import { TermsAndConditionComponent } from './application/terms-and-condition/terms-and-condition.component';
import { ErrorInterceptor } from './core/interceptors/error.interceptor';
import { JwtInterceptor } from './core/interceptors/jwt.interceptor';
import { RoleSelectionComponent } from './role-selection/role-selection.component';
import { LoaderComponent } from './shared/loading-overlay/loading-overlay.component';
import { SharedModule } from './shared/shared.module';
import { CampaignAnalyticsComponent } from './application/campaign-analytics/campaign-analytics.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { CampaignNumericalAnalyticsComponent } from './application/campaign-analytics/campaign-numerical-analytics/campaign-numerical-analytics.component';
import { CampaignGraphicalAnalyticsComponent } from './application/campaign-analytics/campaign-graphical-analytics/campaign-graphical-analytics.component';
import { CampaignResultsDashboardComponent } from './application/campaign-analytics/campaign-results-dashboard/campaign-results-dashboard.component';
import { ChannelImageViewerComponent } from './application/channel-image-viewer/channel-image-viewer.component';

@NgModule({
    declarations: [
        AppComponent,
        LoaderComponent,
        DashboardComponent,
        LiveCampaignsComponent,
        CampaignsPerformanceComponent,
        CampaignsOverviewComponent,
        CampaignRejectModalComponent,
        CampaignEditUserModalComponent,
        CampaignPauseEditVisualsModalComponent,
        CampaignCancelModalComponent,
        CampaignAddChargesModalComponent,
        CampaignRelaunchModalComponent,
        CampaignStopModalComponent,
        CampaignPauseModalComponent,
        TermsAndConditionComponent,
        PrivacyPolicyComponent,
        ContactUsComponent,
        CampaignAnalyticsComponent,
        CampaignNumericalAnalyticsComponent,
        CampaignGraphicalAnalyticsComponent,
        CampaignResultsDashboardComponent,
        CampaignDeleteModalComponent,
        RoleSelectionComponent,
        ScratchPadComponent,
        ChannelImageViewerComponent
    ],
    imports: [
        BrowserModule,
        MatTooltipModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        SharedModule,
        NewCampaignModule,
        MyAccountModule,
        HttpClientModule,
        ToastrModule.forRoot({
            timeOut: 4000,
            positionClass: 'toast-top-right',
            closeButton: true,
            progressBar: false,
            newestOnTop: true,
            preventDuplicates: false,
            enableHtml: true
        }),
        MatSortModule,
        A11yModule,
        ReactiveTypedFormsModule,
        MatAutocompleteModule
    ],
    providers: [
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
        ThemeService
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
